import { createContext } from 'react';

const Context = createContext({
    language: 'ES'
});

export default Context;